// src/components/BusinessModel.tsx
import React from "react";

type Item = {
  id: string;
  title: string;
  iconPath: string;
};

const items: Item[] = [
  { id: "i1", title: "Camioneta brandeada\ny equipada", iconPath: "/images/icons/1camioneta.svg" },
  { id: "i2", title: "Oficina con imagen y\nmobiliario completo", iconPath: "/images/icons/2oficina.svg" },
  { id: "i3", title: "Personal técnico y\noperativo incluido", iconPath: "/images/icons/3personalcap.svg" },
  { id: "i4", title: "Plataforma operativa con\ninteligencia artificial", iconPath: "/images/icons/4IA.svg" },
  { id: "i5", title: "Marketing y publicidad\nprofesional para el primer mes", iconPath: "/images/icons/5Marketing.svg" },
  { id: "i6", title: "Capacitación, soporte y\nasesoría comercial", iconPath: "/images/icons/6capacitación.svg" },
];

type Props = {
  headline?: string;
  highlight?: string;
  subheadline?: string;
  data?: Item[];
};

const BusinessModel: React.FC<Props> = ({
  headline = "Modelo de negocio",
  highlight = "llave en mano",
  subheadline = "Todo lo que necesitas para empezar a operar desde el día uno",
  data = items,
}) => {
  return (
    <section
      aria-label="Modelo de negocio llave en mano"
      className="w-full bg-white py-16 sm:py-20"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        {/* Título */}
        <header className="text-center">
          <h2 className="font-extrabold text-neutral-900 text-2xl sm:text-3xl md:text-4xl lg:text-5xl" style={{ fontSize: 'clamp(1.5rem, 4vw, 3rem)' }}>
            {headline}{" "}
            <span style={{ color: "#F7AC48" }}>{highlight}</span>
          </h2>
          <p className="mt-2 text-neutral-600 text-sm sm:text-base md:text-lg lg:text-xl" style={{ fontSize: 'clamp(0.875rem, 2.5vw, 1.5rem)' }}>
            {subheadline}
          </p>
        </header>

        {/* Grid de cards */}
        <div className="mt-8 grid gap-5 sm:gap-6 md:gap-7 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {data.map(({ id, title, iconPath }) => (
            <article
              key={id}
              className="rounded-lg bg-white shadow-[0_2px_0_rgba(0,0,0,0.03)] hover:shadow-xl hover:scale-105 hover:-translate-y-2 transition-all duration-300 ease-in-out p-4 flex flex-col items-center justify-center text-center gap-3 cursor-pointer"
              style={{
                width: '21rem',
                height: '13.9375rem',
                border: '0.09375rem solid #F7AC48'
              }}
            >
              {/* Ícono circular ámbar */}
              <div className="shrink-0 inline-flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/90">
                <img 
                  src={iconPath} 
                  alt={title}
                  className="h-8 w-8 object-contain"
                />
              </div>

              {/* Texto */}
              <h3 className="text-base sm:text-lg font-semibold text-neutral-800 leading-snug whitespace-pre-line">
                {title}
              </h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessModel;